import { webToCatchFaceConnect } from '../lace/webToCatchFaceConnect'
import { webKnots } from '../../../../common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb, topSidePartOfWebWithJoint } from './parts/sideParts'

export const type28Web = (ctx: CanvasRenderingContext2D, webColor: string, edgeColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1)
  // 縦パーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(605, 94) //左上
  ctx.quadraticCurveTo(560, 206, 560, 206) //左下
  ctx.quadraticCurveTo(591, 240, 602, 270) //右下
  ctx.quadraticCurveTo(685, 211, 685, 211) //右上
  ctx.quadraticCurveTo(652, 132, 605, 94) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // // ヘリ革パーツ
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(605, 94) //左上
  ctx.quadraticCurveTo(560, 206, 560, 206) //左下
  ctx.quadraticCurveTo(569, 215, 569, 215) //右下
  ctx.quadraticCurveTo(614, 101, 614, 101) //右上
  ctx.quadraticCurveTo(605, 92, 605, 92) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(680, 200) //左上
  ctx.quadraticCurveTo(598, 260, 598, 260) //左下
  ctx.quadraticCurveTo(603, 270, 603, 270) //右下
  ctx.quadraticCurveTo(685, 211, 685, 211) //右上
  ctx.quadraticCurveTo(680, 202, 680, 200) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = '#282828'
  ctx.beginPath()
  ctx.moveTo(625, 115) //左上
  ctx.quadraticCurveTo(579, 229, 579, 229) //左下
  ctx.moveTo(672, 185) //右上
  ctx.quadraticCurveTo(592, 247, 592, 247) //右下
  ctx.stroke()
  ctx.closePath()

  // // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // // 縦向き＿左
  ctx.moveTo(627, 118) // 上
  ctx.quadraticCurveTo(583, 228, 583, 228) // 下
  // // 縦向き＿右
  ctx.moveTo(669, 183) // 上
  ctx.quadraticCurveTo(591, 243, 591, 243) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  webToCatchFaceConnect(ctx, laceColor, -35, 15)
  webKnots(ctx, laceColor, 25, -54) // ウェブ先端寄りのウェブ結び目
  webKnots(ctx, laceColor, -20, 20) // 捕球面寄りのウェブ結び目
}
